import { render, staticRenderFns } from "./searchlist.vue?vue&type=template&id=4b2afb44&scoped=true&"
import script from "./searchlist.vue?vue&type=script&lang=js&"
export * from "./searchlist.vue?vue&type=script&lang=js&"
import style0 from "./searchlist.vue?vue&type=style&index=0&id=4b2afb44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2afb44",
  null
  
)

export default component.exports